// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Matches well-attachments-dialog design ─────────────────── */
mat-dialog-content {
  min-width: 480px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

/* Suppress NextPage arrow pseudo-element on btn */
.btn::after { content: '' !important; display: none !important; }

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/add-rig/add-rig.component.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA,kDAAkD;AAClD,cAAc,sBAAsB,EAAE,wBAAwB,EAAE","sourcesContent":["/* ── Matches well-attachments-dialog design ─────────────────── */\nmat-dialog-content {\n  min-width: 480px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n/* Suppress NextPage arrow pseudo-element on btn */\n.btn::after { content: '' !important; display: none !important; }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
